import React, { useEffect, useMemo, useState } from 'react';
import './App.css';

const galleryIds = [
  '19I75AhVmjzemCAI8-Hypjji-tYZgvrSv',
  '12mDze2cggQY7KvA2Urcp7v6dTYn3Fdn5',
  '1C4-pT_fvLPLv5kQk6oM30i_nlOuuoJn2',
  '1QgzHH5-VcLoZixXTuzrHxz8tgUvLT-ir',
  '10vYL-6Q7hPbOX58kdjnK2jviHrUlvdt8',
  '1-OiV-akjysWWiXfd__Xy-XFUJRhrViQq',
  '1PblGZE_UmsczyxzSf-Moqd159u57Rz8x',
  '1pKGRu37_KRU4YOwIuBko-JAKltHqaECw',
  '1ignCTMRuEFKymKLz_xV2Uyvp6p-drltk',
  '1KK8_dtU6Hm42EdIHQm170_TCcRI2IxAc',
  '1Omo0soD_fYvGNPZ2VPfPv6N6s6EMMZup',
  '11b0VUrffbo55pj58g1eYIt8Hq-mlNt6a'
];

const faqItems = [
  ['На сколько человек рассчитан коттедж?', 'Спальных мест в доме — 12.'],
  ['Сколько человек входит в базовую стоимость?', 'Базовая стоимость актуальна до 15 человек.'],
  ['Какая доплата после 15 человек?', 'После 15 человек доплата составляет 1 000 ₽ за человека.'],
  ['Во сколько заезд и выезд?', 'Заезд — с 15:00, выезд — до 12:00.'],
  ['Сколько стоят дополнительные дрова?', 'Каждый следующий мешок дров стоит 600 ₽.'],
  ['Что входит в стоимость аренды?', 'Баня на дровах и бассейн уже входят в стоимость аренды.']
];

function App() {
  const images = useMemo(
    () => galleryIds.map((id) => ({ thumb: `https://drive.google.com/thumbnail?id=${id}&sz=w1200`, full: `https://drive.google.com/thumbnail?id=${id}&sz=w2200` })),
    []
  );
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    document.body.style.overflow = lightboxOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [lightboxOpen]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add('in-view')),
      { threshold: 0.14 }
    );
    document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (!lightboxOpen) return;
      if (event.key === 'Escape') setLightboxOpen(false);
      if (event.key === 'ArrowLeft') setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
      if (event.key === 'ArrowRight') setActiveIndex((prev) => (prev + 1) % images.length);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [images.length, lightboxOpen]);

  return (
    <div className="app">
      <header className="topbar">
        <div className="container topbar-inner">
          <a href="#hero" className="brand" aria-label="Оазис">
            <span className="brand-mark">О</span>
            <span>Коттедж «Оазис»</span>
          </a>
          <nav className="nav" aria-label="Основная навигация">
            <a href="#about">О доме</a>
            <a href="#amenities">Удобства</a>
            <a href="#gallery">Галерея</a>
            <a href="#prices">Цены</a>
            <a href="#location">Локация</a>
            <a href="#contacts">Контакты</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="hero">
          <div className="container">
            <div className="hero-shell reveal">
              <div className="hero-media" />
              <div className="hero-grid">
                <div className="hero-copy">
                  <span className="eyebrow">Новосибирск / Новосибирская область</span>
                  <div className="hero-kicker">Коттедж для отдыха компанией до 15 гостей</div>
                  <h1>Оазис для отдыха компанией до 15 гостей</h1>
                  <p className="lead">Просторный загородный дом для семейных выходных, встреч с друзьями и камерных праздников.</p>
                  <div className="hero-list">
                    {['Баня', 'Чан', 'Бассейн', 'Бильярд', '4 спальни'].map((chip) => (
                      <span className="hero-chip" key={chip}>{chip}</span>
                    ))}
                  </div>
                  <p className="hero-note">Базовая стоимость включает до 15 гостей. При большем составе — доплата 1 000 ₽ за человека.</p>
                  <div className="btn-row">
                    <a className="btn btn-primary" href="#contacts">Уточнить свободные даты</a>
                    <a className="btn btn-secondary" href="https://t.me/DymDim24" target="_blank" rel="noreferrer">Telegram</a>
                    <a className="btn btn-secondary" href="https://max.ru/u/f9LHodD0cOKp1ouRcqsanTrKj8WsyQUc2bfk7QhcbWRjj2NrACz-88DywKE" target="_blank" rel="noreferrer">MAX</a>
                    <a className="btn btn-secondary" href="tel:+79139165751">Позвонить</a>
                  </div>
                </div>
                <aside className="hero-card" aria-label="Карточка с ценами">
                  <img
                    className="hero-card-photo"
                    src="https://drive.google.com/thumbnail?id=1xEWkP93FjEGw1sT__evYaQFw-rkWelKB&sz=w1600"
                    alt="Интерьер коттеджа Оазис"
                  />
                  <div className="eyebrow">Актуальные цены</div>
                  <div className="price-list">
                    {[
                      ['Пн — Чт', '12 000 ₽'],
                      ['Пятница', '15 000 ₽'],
                      ['Суббота', '20 000 ₽'],
                      ['Воскресенье', '15 000 ₽']
                    ].map(([label, price]) => (
                      <div className="price-item" key={label}><span>{label}</span><strong>{price}</strong></div>
                    ))}
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="about">
          <div className="container grid-2">
            <div className="section-head reveal">
              <span className="eyebrow">О доме</span>
              <h2>Просторный коттедж, где всё собрано ради спокойного отдыха</h2>
            </div>
            <div className="reveal stack">
              <p className="lead">«Оазис» — дом, в котором удобно и отдыхать, и собираться компанией на важные события.</p>
              <p className="lead">Внутри 4 спальни, большая гостиная, кухня, бильярд и SPA-зона с баней на дровах и бассейном.</p>
              <div className="accent-strip">Баня расположена в доме, топится самостоятельно и доступна без ограничений по времени.</div>
            </div>
          </div>
        </section>

        <section className="section" id="amenities">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Удобства</span>
              <h2>Всё, что нужно для комфортного отдыха</h2>
              <p className="lead">Один мешок дров включён в стоимость, каждый следующий — 600 ₽.</p>
            </div>
            <div className="feature-grid">
              {['12 спальных мест', '4 спальни', 'Баня на дровах', 'Бассейн', 'Молодильный чан 6 000 ₽', 'Бильярд', 'Кухня и техника', 'TV и колонка'].map((item) => (
                <article className="card reveal" key={item}><h3>{item}</h3></article>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="scenarios">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Сценарии отдыха</span>
              <h2>Подходит для отдыха, встреч и небольших праздников</h2>
            </div>
            <div className="scenario-grid">
              {['Банный отдых', 'Встреча друзей', 'Семейный выезд', 'День рождения или юбилей'].map((item) => (
                <article className="card reveal" key={item}><h3>{item}</h3></article>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="gallery">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Фотогалерея</span>
              <h2>Фотографии коттеджа «Оазис»</h2>
            </div>
            <div className="gallery-masonry reveal">
              {images.map((image, index) => (
                <button key={image.thumb} className="gallery-item" type="button" aria-label={`Открыть фото ${index + 1}`} onClick={() => { setActiveIndex(index); setLightboxOpen(true); }}>
                  <img loading="lazy" src={image.thumb} alt={`Фотография коттеджа Оазис ${index + 1}`} />
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="prices">
          <div className="container">
            <div className="section-head reveal"><span className="eyebrow">Цены</span><h2>Актуальные цены по дням недели</h2></div>
            <div className="price-grid">
              {['Понедельник — Четверг: 12 000 ₽', 'Пятница: 15 000 ₽', 'Суббота: 20 000 ₽', 'Воскресенье: 15 000 ₽'].map((item) => (
                <article className="card reveal" key={item}><h3>{item}</h3></article>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="fit">
          <div className="container">
            <div className="section-head reveal"><span className="eyebrow">Подходит для</span><h2>Сценарии, под которые «Оазис» выбирают чаще всего</h2></div>
            <div className="fit-grid">
              {['Семейный отдых', 'Встреча друзей', 'День рождения', 'Юбилей', 'Банный weekend', 'Выезд за город'].map((item) => (
                <article className="card reveal" key={item}><h3>{item}</h3></article>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="location">
          <div className="container">
            <div className="section-head reveal"><span className="eyebrow">Локация</span><h2>Удобно добраться и построить маршрут</h2></div>
            <div className="contact-grid">
              <article className="card reveal location-card">
                <iframe
                  className="map-frame"
                  title="Карта расположения коттеджа Оазис"
                  loading="lazy"
                  src="https://yandex.ru/map-widget/v1/?ll=83.024198%2C55.097620&z=14&pt=83.024198,55.097620,pm2rdm"
                />
              </article>
              <article className="card reveal"><h3>Коттедж «Оазис»</h3><p>Новосибирск / Новосибирская область</p><p>Координаты: 55.097620, 83.024198</p></article>
            </div>
          </div>
        </section>

        <section className="section" id="contacts">
          <div className="container contact-grid">
            <div className="section-head reveal">
              <span className="eyebrow">Контакты</span>
              <h2>Быстрый контакт без лишних шагов</h2>
              <div className="btn-row">
                <a className="btn btn-primary" href="tel:+79139165751">Позвонить</a>
                <a className="btn btn-secondary" href="https://t.me/DymDim24" target="_blank" rel="noreferrer">Telegram</a>
                <a className="btn btn-secondary" href="https://max.ru/u/f9LHodD0cOKp1ouRcqsanTrKj8WsyQUc2bfk7QhcbWRjj2NrACz-88DywKE" target="_blank" rel="noreferrer">MAX</a>
              </div>
            </div>
            <div className="contact-stack reveal">
              <a className="contact-link" href="tel:+79139165751"><strong>+7 913 916 57 51</strong><span>Позвонить</span></a>
              <a className="contact-link" href="https://t.me/DymDim24" target="_blank" rel="noreferrer"><strong>@DymDim24</strong><span>Telegram</span></a>
              <a className="contact-link" href="https://max.ru/u/f9LHodD0cOKp1ouRcqsanTrKj8WsyQUc2bfk7QhcbWRjj2NrACz-88DywKE" target="_blank" rel="noreferrer"><strong>MAX</strong><span>Открыть</span></a>
            </div>
          </div>
        </section>

        <section className="section" id="faq">
          <div className="container">
            <div className="section-head reveal"><span className="eyebrow">FAQ</span><h2>Ответы на частые вопросы</h2></div>
            <div className="reveal">
              {faqItems.map(([q, a]) => (
                <details key={q} className="faq-item"><summary>{q}</summary><div className="faq-answer">{a}</div></details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-card reveal">
            <div><h3>Оазис — тёплый загородный отдых без лишнего шума</h3><p className="muted">Баня, бассейн, бильярд, 4 спальни и быстрый контакт в одном месте.</p></div>
            <div className="btn-row"><a className="btn btn-primary" href="https://t.me/DymDim24" target="_blank" rel="noreferrer">Уточнить даты</a></div>
          </div>
        </div>
      </footer>

      <div className="sticky-actions" aria-label="Быстрые действия">
        <a href="tel:+79139165751">Звонок</a>
        <a href="https://t.me/DymDim24" target="_blank" rel="noreferrer">Telegram</a>
        <a href="https://max.ru/u/f9LHodD0cOKp1ouRcqsanTrKj8WsyQUc2bfk7QhcbWRjj2NrACz-88DywKE" className="primary" target="_blank" rel="noreferrer">MAX</a>
      </div>

      {lightboxOpen && (
        <div className="lightbox open" role="dialog" aria-label="Просмотр галереи" onClick={() => setLightboxOpen(false)}>
          <div className="lightbox-dialog" onClick={(event) => event.stopPropagation()}>
            <div className="lightbox-top"><div><div className="eyebrow">Галерея</div><p className="muted">{`Фото ${activeIndex + 1} из ${images.length}`}</p></div><button type="button" onClick={() => setLightboxOpen(false)}>Закрыть</button></div>
            <figure className="lightbox-figure"><img src={images[activeIndex].full} alt="Фотография коттеджа Оазис" /></figure>
            <div className="lightbox-nav"><button type="button" onClick={() => setActiveIndex((prev) => (prev - 1 + images.length) % images.length)}>Назад</button><button type="button" onClick={() => setActiveIndex((prev) => (prev + 1) % images.length)}>Вперёд</button></div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
